import { BoardUserActivityType } from '@/api/workspaceSettings/queries';
import { uuid } from '@/_core/utils/uuid';
import {
    AddAnnotation as AddAnnotationCommand,
    DeleteAnnotation as DeleteAnnotationCommand,
    EditAnnotation as EditAnnotationCommand,
    MoveAnnotation,
} from '..';
import * as storymapStoreModule from '../../../store';
import { ReorderAnnotations } from '../../../store';
import { AddAnnotation } from '../../../store/actions/annotations/addAnnotation';
import { DeleteAnnotation } from '../../../store/actions/annotations/deleteAnnotation';
import { EditAnnotation } from '../../../store/actions/annotations/editAnnotation';

export const createAddAnnotationCommand = async (action: AddAnnotation) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const activityId = await uuid.create();

    const boardActivity: any = {
        Datetime: new Date().toJSON(),
        EstimationUnit: '',
        Id: activityId,
        StorymapId: state.id,
        Content: action.name,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.AnnotationCreated,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    const cmd = new AddAnnotationCommand(state.id, action.id, action.name, action.color, action.icon);

    cmd.BoardActivity = boardActivity;

    return cmd;
};

export const createDeleteAnnotationCommand = async (action: DeleteAnnotation) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const activityId = await uuid.create();

    const annotation = state.annotations.find((x) => x.id === action.id);

    const boardActivity: any = {
        Datetime: new Date().toJSON(),
        EstimationUnit: '',
        Id: activityId,
        StorymapId: state.id,
        Content: annotation.name,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.AnnotationDeleted,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    const cmd = new DeleteAnnotationCommand(state.id, action.id, annotation.name);

    cmd.BoardActivity = boardActivity;

    return cmd;
};

export const createEditAnnotationCommand = async (action: EditAnnotation) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const activityId = await uuid.create();

    const boardActivity: any = {
        Datetime: new Date().toJSON(),
        EstimationUnit: '',
        Id: activityId,
        StorymapId: state.id,
        Content: action.name,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.AnnotationEdited,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    const cmd = new EditAnnotationCommand(state.id, action.id, action.name, action.color, action.icon);

    cmd.BoardActivity = boardActivity;

    return cmd;
};

export const createMoveAnnotationCommand = async (action: ReorderAnnotations) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const activityId = await uuid.create();
    const annotation = state.annotations.find(x => x.id == action.id);

    const boardActivity: any = {
        Datetime: new Date().toJSON(),
        EstimationUnit: '',
        Id: activityId,
        StorymapId: state.id,
        Content: annotation.name,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.AnnotationMoved,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    const cmd = new MoveAnnotation(state.id, action.id, action.newOrder);

    cmd.BoardActivity = boardActivity;

    return cmd;
};
